import { fieldTypes } from '@constants/constant';
import { API_URLS } from '@core/api-url.enum';
import { Fields } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';

export const RESOURCE_ROUTE_DISPLAY_NAMES: { [key: string]: string } = {
  ANNOUNCEMENT: 'Announcements',
  TIPS_TUTORIALS: 'Guides',
  SERVICE_PROVIDER: 'Service Providers'
};

export const RESOURCE_API_MAP: { [key: string]: string } = {
  ANNOUNCEMENT: API_URLS.announcements,
  TIPS_TUTORIALS: API_URLS.tipsTutorials,
  SERVICE_PROVIDER: API_URLS.serviceProviders
};

export const LABELS = {
  SEARCH_ANNOUNCEMENTS: 'Search Announcements',
  SEARCH_TIPS_TUTORIALS: 'Search Tips & Tutorials',
  SEARCH_GUIDES: 'Search Guides',
  LIKES: 'Likes',
  COMMENTS: 'Comments',
  UNREAD: 'Unread',
  COMMENTS_TITLE: 'Comments',
  GET_INTRODUCED: 'GET INTRODUCED',
  CANCEL: 'Cancel',
  ALREADY_LEAD_GENERATED: 'Introduction Made',
  COMMENT: 'Comment',
  LIKE: 'Like',
  PROCEED: 'Proceed',
  SEARCH_FAQS: 'Search FAQs',
  FAQS: 'FAQs',
  CREATOR: 'CREATOR',
  LOAD_MORE_FAQ: 'LOAD MORE FAQs',
  SUBMIT: 'SUBMIT',
  GLOBAL: 'GLOBAL',
  ADVERTISER: 'ADVERTISER',
  CREATOR_ONBOARDING: 'CREATOR_ONBOARDING',
  NEXT: 'Next Step',
  PREVIOUS: 'Previous',
  PORTFOLIO_PREVIEW: 'Portfolio Preview'
};

export const Messages = {
  SOMETHING_WENT_WRONG: 'Something went wrong',
  FAILED_TO_LOAD_ANNOUNCEMENTS: 'Failed to load announcements',
  FAILED_TO_LOAD_TIPS_TUTORIALS: 'Failed to load tips & tutorials',
  FAILED_TO_LOAD_RESOURCES: 'Failed to load resources',
  INVALID_URL: 'Invalid URL',
  NO_ANNOUNCEMENTS_FOUND: 'No Announcements found',
  NO_TIPS_TUTORIALS_FOUND: 'No Tips & Tutorials found',
  NO_RESOURCES_FOUND: 'No Resources found',
  NO_SERVICE_PROVIDERS_FOUND: 'No Service Providers found',
  GET_INTRODUCED_TO_SERVICE_PROVIDER:
    "We'll send an email to <name> to let them know of your interest in their services. We'll share your name, email, and TopFan profile. The <name> will reply back to you directly for next steps.",
  GET_INTRODUCED_TO_SERVICE_PROVIDER_FOOTER:
    'Note: TopFan does not offer support or guarantees related to <name> products or services. The relationship with you and <name> is not covered by TopFan terms. By initiating this introduction, you agree to these terms and conditions.',
  GET_INTRODUCED_TO: 'Get Introduced to',
  ABOUT: 'About',
  PORTFOLIO: 'Portfolio',
  NO_DATA_FOUND: 'No Data Found',
  HAVE_QUESTION: 'Have a question or need to resolve a technical issue?',
  HAVE_QUESTION_SUB:
    "We are here to help you succeed! Ask your questions using the form and we'll be in touch with you shortly.",
  HELP_CENTER_FAQ: 'Help Center & FAQ'
};
export const RESOURCE_TYPE = {
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  TIPS_TUTORIALS: 'TIPS_TUTORIALS',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER'
};
export const typeFilterField = {
  type: fieldTypes.SELECT,
  label: '',
  name: 'filter',
  class: 'col-12',
  placeholder: 'Select Service Provider Type',
  options: [],
  labelKey: 'label',
  valueKey: 'value'
};

export const SERVICE_PROVIDER_LABELS = {
  ALL_SERVICE_PROVIDERS: 'All Service Providers'
};

export const RESPONSE_FIELD: Fields = {
  sections: [
    {
      title: '',
      fields: [
        {
          type: fieldTypes.SELECT,
          label: 'Inquiry Type',
          name: 'inquiry_type',
          class: 'col-12 col-lg-6',
          placeholder: 'Select Inquiry Type',
          labelKey: 'name',
          valueKey: 'name',
          options: [],
          validation: {
            required: {
              message: 'Inquiry Type is required'
            }
          }
        },
        {
          type: fieldTypes.MOBILE_INPUT,
          label: 'Mobile Number',
          name: 'phone_number',
          class: 'col-12 col-lg-6',
          mobile: {
            preferredCountries: [
              CountryISO.UnitedStates,
              CountryISO.UnitedKingdom
            ] as CountryISO[],
            enableAutoCountrySelect: true,
            enablePlaceholder: false,
            searchCountryFlag: true,
            searchCountryField: SearchCountryField,
            selectFirstCountry: false,
            selectedCountryISO: CountryISO.UnitedStates,
            phoneValidation: true,
            separateDialCode: true
          },
          validation: {
            required: {
              message: 'Mobile number is required'
            },
            validatePhoneNumber: {
              message: 'Please enter a valid mobile number'
            }
          }
        },
        {
          type: fieldTypes.TEXT_AREA,
          label: 'How can we help you?',
          placeholder: 'Please provide details here...',
          name: 'help_query',
          class: 'col-12',
          validation: {
            required: {
              message: 'Field is required'
            },
            minlength: {
              value: 2,
              message: 'Minimum 2 characters allowed'
            },
            maxlength: {
              value: 1000,
              message: 'Maximum 1000 characters allowed'
            }
          }
        }
      ]
    }
  ]
};
